import React, { useEffect, useState } from "react";
import api, { formatApiError } from "../lib/api";
import { toast } from "sonner";
import { FileText, Download } from "lucide-react";

const eur = (v) => `€ ${Number(v || 0).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const fmtDate = (iso) => (iso ? new Date(`${iso.slice(0, 10)}T12:00:00`).toLocaleDateString("it-IT") : "—");

export const downloadPdf = async (url, filename) => {
  try {
    const { data } = await api.get(url, { responseType: "blob" });
    const href = URL.createObjectURL(data); const a = document.createElement("a"); a.href = href; a.download = filename; a.click(); URL.revokeObjectURL(href);
  } catch (e) { toast.error(formatApiError(e)); }
};

export const TenantReceipts = ({ refreshKey }) => {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/billing/receipts").then(({ data }) => setRows(data)).catch(() => setRows([])); }, [refreshKey]);
  if (!rows.length) return null;
  return (
    <div className="border-t border-zinc-800 pt-3" data-testid="billing-receipts">
      <div className="order-field-label mb-1 flex items-center gap-1"><FileText className="h-3 w-3" /> Ricevute di pagamento</div>
      <ul className="text-xs space-y-1">
        {rows.map((r) => (
          <li key={r.id} className="flex items-center justify-between gap-2" data-testid={`billing-receipt-${r.id}`}>
            <span>n. <b>{r.number}</b> · {fmtDate(r.date)} · {eur(r.gross)}</span>
            <button type="button" onClick={() => downloadPdf(`/billing/receipts/${r.id}/pdf`, `ricevuta_${r.number.replace("/", "-")}.pdf`)} data-testid={`billing-receipt-pdf-${r.id}`}
              className="inline-flex items-center gap-1 text-[color:var(--vivi)] hover:underline"><Download className="h-3 w-3" /> PDF</button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TenantReceipts;
